export const eventfulCategoriesWebSide = {
    'category': [
        {
            'name': 'Concerts &amp; Tour Dates',
            'id': 'music'
        },
        // {
        //     'name': 'Conferences &amp; Tradeshows',
        //     'id': 'conference'
        // },
        {
            'name': 'Comedy',
            'id': 'comedy'
        },
        // {
        //     'name': 'Education',
        //     'id': 'learning_education'
        // },
        {
            'name': 'Kids &amp; Family',
            'id': 'family_fun_kids'
        },
        {
            'name': 'Festivals',
            'id': 'festivals_parades'
        },
        {
            'name': 'Film',
            'id': 'movies_film'
        },
        {
            'name': 'Food &amp; Wine',
            'id': 'food'
        },
        // {
        //     'name': 'Fundraising &amp; Charity',
        //     'id': 'fundraisers'
        // },
        {
            'name': 'Art Galleries &amp; Exhibits',
            'id': 'art'
        },
        // {
        //     'name': 'Health &amp; Wellness',
        //     'id': 'support'
        // },
        {
            'name': 'Holiday',
            'id': 'holiday'
        },
        {
            'name': 'Literary &amp; Books',
            'id': 'books'
        },
        {
            'name': 'Museums &amp; Attractions',
            'id': 'attractions'
        },
        // {
        //     'name': 'Neighborhood',
        //     'id': 'community'
        // },
        // {
        //     'name': 'Business &amp; Networking',
        //     'id': 'business'
        // },
        {
            'name': 'Nightlife &amp; Singles',
            'id': 'singles_social'
        },
        // {
        //     'name': 'University &amp; Alumni',
        //     'id': 'schools_alumni'
        // },
        // {
        //     'name': 'Organizations &amp; Meetups',
        //     'id': 'clubs_associations'
        // },
        {
            'name': 'Outdoors &amp; Recreation',
            'id': 'outdoors_recreation'
        },
        {
            'name': 'Performing Arts',
            'id': 'performing_arts'
        },
        // {
        //     'name': 'Pets',
        //     'id': 'animals'
        // },
        // {
        //     'name': 'Politics &amp; Activism',
        //     'id': 'politics_activism'
        // },
        // {
        //     'name': 'Sales &amp; Retail',
        //     'id': 'sales'
        // },
        // {
        //     'name': 'Science',
        //     'id': 'science'
        // },
        // {
        //     'name': 'Religion &amp; Spirituality',
        //     'id': 'religion_spirituality'
        // },
        {
            'name': 'Sports',
            'id': 'sports'
        },
        // {
        //     'name': 'Technology',
        //     'id': 'technology'
        // },
        {
            'name': 'Other &amp; Miscellaneous',
            'id': 'other'
        }
    ]
};


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/services/default.images/eventful.categories.web.side.ts